export default "__VITE_ASSET__BLjTw5qU__"